import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_LISTAR_ATRAS } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
import Select from "react-select";
import cargandoCard from "../../../components/cargando-card";
import { SELECT_HABILITADO_DESHABILITADO } from "../../../utils/const/const-select-habilitado-deshabilitado";
import { actualizarConductor, createConductor } from "../../../api/api-conductor";
import "react-widgets/styles.css";
import DatePicker from "react-widgets/DatePicker";
import moment from "moment";
import momentLocalizer from "react-widgets-moment";

new momentLocalizer(moment);

const styles = {
  headerContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
  },
  line: {
    flex: 1,
    borderBottom: "1px solid #000",
  },
  headerText: {
    marginRight: "10px",
    fontWeight: "bold",
    fontSize: "16px",
  },
};

export default function Conductor() {
  const location = useLocation();
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [titulo, setTitulo] = useState("");
  const [formData, setFormData] = useState({});
  const [listHabilitado, setListHabilitado] = useState([]);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);

  const [fechaNacimiento, setFechaNacimiento] = useState(new Date(moment().format("YYYY-MM-DD")));
  const [expiracionLicencia, setExpiracionLicencia] = useState(new Date(moment().format("YYYY-MM-DD")));

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.formData);
        setTitulo(data.titulo);
        if (data.formData.fechaNacimiento !== null) {
          const [year, month, day] = moment.utc(data.formData.fechaNacimiento).format("YYYY-MM-DD").toString().split('-').map(Number);
          const dob = new Date(year, month - 1, day);
          setFechaNacimiento(dob);
        }
        if (data.formData.expiracionLicencia !== null) {
          const [year, month, day] = moment.utc(data.formData.expiracionLicencia).format("YYYY-MM-DD").toString().split('-').map(Number);
          const expLic = new Date(year, month - 1, day);
          setExpiracionLicencia(expLic);
        }
      }
      setListHabilitado(SELECT_HABILITADO_DESHABILITADO);
      // const response = await obtenerInfoVehiculo({ idVehiculo: data.idVehiculo });
      const habilitado = SELECT_HABILITADO_DESHABILITADO.find(e => e.value === data.formData.habilitado);
      if (habilitado !== undefined) {
        setHabilitadoSelected(habilitado);
      }
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  };

  const charLimits = {
    nombre: 64,
    apellidoPaterno: 64,
    apellidoMaterno: 64,
    correo: 128,
    celularPersonal: 24,
    direccionVivienda: 256,
    numeroDocumentoIdentidad: 48,
    numeroLicencia: 48,
    categoriaLicencia: 4,
    nombreContacto: 128,
    celularContacto: 24,
    vinculoContacto: 48,
    emailContacto: 128,
    direccionViviendaContacto: 256,
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (value.length <= charLimits[name]) {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validate = () => {
    try {
      let message = "";
      if (String(formData.nombre).trim().length === 0) {
        message = message + "Debe ingresar nombre" + '\n';
      }
      if (String(formData.apellidoPaterno).trim().length === 0) {
        message = message + "Debe ingresar apellido paterno" + '\n';
      }
      if (String(fechaNacimiento).trim().length === 0) {
        message = message + "Debe ingresar fecha nacimiento" + '\n';
      }
      if (String(formData.numeroDocumentoIdentidad).trim().length === 0) {
        message = message + "Debe ingresar documento identidad" + '\n';
      }
      if (String(formData.numeroLicencia).trim().length === 0) {
        message = message + "Debe ingresar nummero licencia" + '\n';
      }
      if (String(formData.categoriaLicencia).trim().length === 0) {
        message = message + "Debe ingresar categoria licencia" + '\n';
      }
      if (String(expiracionLicencia).trim().length === 0) {
        message = message + "Debe ingresar expiracion licencia" + '\n';
      }
      if (message.length > 0) {
        alert(message);
        return false;
      }
      return true;
    } catch (err) {
      console.log('validate err');
      console.log(err);
      return false;
    }
  }

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('formData');
    // console.log(formData);
    const valid = validate();
    if (valid === false) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = formData.id;
    objEnviar.nombre = formData.nombre;
    objEnviar.apellidoPaterno = formData.apellidoPaterno;
    objEnviar.apellidoMaterno = formData.apellidoMaterno;
    objEnviar.correo = formData.correo;
    objEnviar.fechaNacimiento = moment(fechaNacimiento).format('YYYY/MM/DD').toString();
    objEnviar.celularPersonal = formData.celularPersonal;
    objEnviar.direccionVivienda = formData.direccionVivienda;
    objEnviar.numeroDocumentoIdentidad = formData.numeroDocumentoIdentidad;
    objEnviar.numeroLicencia = formData.numeroLicencia;
    objEnviar.categoriaLicencia = formData.categoriaLicencia;
    objEnviar.expiracionLicencia = moment(expiracionLicencia).format('YYYY/MM/DD').toString();
    objEnviar.nombreContacto = formData.nombreContacto;
    objEnviar.celularContacto = formData.celularContacto;
    objEnviar.vinculoContacto = formData.vinculoContacto;
    objEnviar.emailContacto = formData.emailContacto;
    objEnviar.direccionViviendaContacto = formData.direccionViviendaContacto;
    objEnviar.habilitado = habilitadoSelected !== null ? habilitadoSelected.value : 0;
    if (formData.id === 0) {
      // console.log('crear correo');
      const response = await createConductor(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        alert('Se creo correctamente');
        handleCancelClick();
      }
      if (response.error === true) {
        alert('No se pudo crear');
      }
    }
    if (formData.id !== 0) {
      // console.log('actualizar correo');
      const response = await actualizarConductor(objEnviar);
      // console.log('modificado');
      // console.log(modificado);
      if (response.error === false) {
        alert('Se modifico correctamente');
        handleCancelClick();
      }
      if (response.error === true) {
        alert('No se pudo modificar');
      }
    }
  };

  const informacionBasicaForm = () => {
    return (
      <>
        {titleForm("Informacion Basica")}
        <div className="grid grid-cols-12 gap-4 mt-4">
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nombre">
              Nombre<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="nombre"
              name="nombre"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
              placeholder="Ingrese Usuario"
              maxLength={charLimits.nombre}
              onChange={handleChange}
              value={formData.nombre}
            />
            <p className="text-sm text-gray-500 flex justify-end">{formData.nombre.length}/{charLimits.nombre}</p>
          </div>
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="apellidoPaterno">
              Apellido Paterno<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="apellidoPaterno"
              name="apellidoPaterno"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
              placeholder="Apellido Paterno"
              maxLength={charLimits.apellidoPaterno}
              onChange={handleChange}
              value={formData.apellidoPaterno}
            />
            <p className="text-sm text-gray-500 flex justify-end">{formData.apellidoPaterno.length}/{charLimits.apellidoPaterno}</p>
          </div>
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="apellidoMaterno">
              Apellido Materno
            </label>
            <input
              type="text"
              id="apellidoMaterno"
              name="apellidoMaterno"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
              placeholder="Apellido Materno"
              maxLength={charLimits.apellidoMaterno}
              onChange={handleChange}
              value={formData.apellidoMaterno}
            />
            <p className="text-sm text-gray-500 flex justify-end">{formData.apellidoMaterno.length}/{charLimits.apellidoMaterno}</p>
          </div>
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="correo">
              Correo
            </label>
            <input
              type="email"
              id="correo"
              name="correo"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
              placeholder="Email"
              maxLength={charLimits.correo}
              onChange={handleChange}
              value={formData.correo}
            />
            <p className="text-sm text-gray-500 flex justify-end">{formData.correo.length}/{charLimits.correo}</p>
          </div>
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="fechaNacimiento">
              Fecha Nacimiento<span className="text-red-500">*</span>
            </label>
            <DatePicker
              defaultValue={fechaNacimiento}
              value={fechaNacimiento}
              valueFormat={{ dateStyle: "medium" }}
              onChange={(date) => {
                setFechaNacimiento(date);
              }}
            />
          </div>
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="celularPersonal">
              Celular Personal
            </label>
            <input
              type="text"
              id="celularPersonal"
              name="celularPersonal"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
              placeholder="Celular Personal"
              maxLength={charLimits.celularPersonal}
              onChange={handleChange}
              value={formData.celularPersonal}
            />
            <p className="text-sm text-gray-500 flex justify-end">{formData.celularPersonal.length}/{charLimits.celularPersonal}</p>
          </div>
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="direccionVivienda">
              Direccion Vivienda
            </label>
            <textarea
              type="text"
              id="direccionVivienda"
              name="direccionVivienda"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
              placeholder="Direccion Vivienda"
              maxLength={charLimits.direccionVivienda}
              onChange={handleChange}
              value={formData.direccionVivienda}
              rows={3}
            />
            <p className="text-sm text-gray-500 flex justify-end">{formData.direccionVivienda.length}/{charLimits.direccionVivienda}</p>
          </div>
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">

          </div>
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">

          </div>
        </div>
        {titleForm("Informacion Documentos")}
        <div className="grid grid-cols-12 gap-4 mt-4">
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="numeroDocumentoIdentidad">
              Numero Documento Identidad<span className="text-red-500">*</span>
            </label>
            <input
              type="number"
              id="numeroDocumentoIdentidad"
              name="numeroDocumentoIdentidad"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
              placeholder="Numero Documento Identidad"
              maxLength={charLimits.numeroDocumentoIdentidad}
              onChange={handleChange}
              value={formData.numeroDocumentoIdentidad}
              min={0}
            />
            <p className="text-sm text-gray-500 flex justify-end">{formData.numeroDocumentoIdentidad.length}/{charLimits.numeroDocumentoIdentidad}</p>
          </div>
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="numeroLicencia">
              Numero Licencia<span className="text-red-500">*</span>
            </label>
            <input
              type="number"
              id="numeroLicencia"
              name="numeroLicencia"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
              placeholder="Numero Licencia"
              maxLength={charLimits.numeroLicencia}
              onChange={handleChange}
              value={formData.numeroLicencia}
              min={0}
            />
            <p className="text-sm text-gray-500 flex justify-end">{formData.numeroLicencia.length}/{charLimits.numeroLicencia}</p>
          </div>
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="categoriaLicencia">
              Categoria Licencia<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="categoriaLicencia"
              name="categoriaLicencia"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
              placeholder="Categoria Licencia"
              maxLength={charLimits.categoriaLicencia}
              onChange={handleChange}
              value={formData.categoriaLicencia}
              min={0}
            />
            <p className="text-sm text-gray-500 flex justify-end">{formData.categoriaLicencia.length}/{charLimits.categoriaLicencia}</p>
          </div>
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="expiracionLicencia">
              Expiracion Licencia<span className="text-red-500">*</span>
            </label>
            <DatePicker
              defaultValue={expiracionLicencia}
              value={expiracionLicencia}
              valueFormat={{ dateStyle: "medium" }}
              onChange={(date) => {
                setExpiracionLicencia(date);
              }}
            />
          </div>
        </div>
        {titleForm("Informacion Contacto")}
        <div className="grid grid-cols-12 gap-4 mt-4">
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nombreContacto">
              Nombre Contacto
            </label>
            <input
              type="text"
              id="nombreContacto"
              name="nombreContacto"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
              placeholder="Nombre Contacto"
              maxLength={charLimits.nombreContacto}
              onChange={handleChange}
              value={formData.nombreContacto}
              min={0}
            />
            <p className="text-sm text-gray-500 flex justify-end">{formData.nombreContacto.length}/{charLimits.nombreContacto}</p>
          </div>
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="celularContacto">
              Celular Contacto
            </label>
            <input
              type="text"
              id="celularContacto"
              name="celularContacto"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
              placeholder="Celular Contacto"
              maxLength={charLimits.celularContacto}
              onChange={handleChange}
              value={formData.celularContacto}
              min={0}
            />
            <p className="text-sm text-gray-500 flex justify-end">{formData.celularContacto.length}/{charLimits.celularContacto}</p>
          </div>
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="vinculoContacto">
              Vinculo Contacto
            </label>
            <input
              type="text"
              id="vinculoContacto"
              name="vinculoContacto"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
              placeholder="Vinculo Contacto"
              maxLength={charLimits.vinculoContacto}
              onChange={handleChange}
              value={formData.vinculoContacto}
              min={0}
            />
            <p className="text-sm text-gray-500 flex justify-end">{formData.vinculoContacto.length}/{charLimits.vinculoContacto}</p>
          </div>
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="emailContacto">
              Email Contacto
            </label>
            <input
              type="email"
              id="emailContacto"
              name="emailContacto"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
              placeholder="Email Contacto"
              maxLength={charLimits.emailContacto}
              onChange={handleChange}
              value={formData.emailContacto}
              min={0}
            />
            <p className="text-sm text-gray-500 flex justify-end">{formData.emailContacto.length}/{charLimits.emailContacto}</p>
          </div>
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="direccionViviendaContacto">
              Direccion Vivienda Contacto
            </label>
            <textarea
              type="email"
              id="direccionViviendaContacto"
              name="direccionViviendaContacto"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
              placeholder="Direccion Vivienda Contacto"
              maxLength={charLimits.direccionViviendaContacto}
              onChange={handleChange}
              value={formData.direccionViviendaContacto}
              min={0}
            />
            <p className="text-sm text-gray-500 flex justify-end">{formData.direccionViviendaContacto.length}/{charLimits.direccionViviendaContacto}</p>
          </div>
        </div>

        {titleForm("Extra")}
        <div className="grid grid-cols-12 gap-4 mt-4">
          <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-2">
            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
              Habilitado
            </label>
            <Select options={listHabilitado} isSearchable='true'
              isClearable='true'
              value={habilitadoSelected}
              onChange={(event) => setHabilitadoSelected(event)}
              placeholder='SELECCIONE HABILITADO'
            />
          </div>
        </div>
      </>
    );
  };

  const titleForm = (title) => {
    return (
      <div style={styles.headerContainer}>
        <span style={styles.headerText}>{title}</span>
        <div style={styles.line}></div>
      </div>
    );
  }

  const handleAtrasClick = () => {
    history.goBack();
  };

  const render = () => {
    // console.log('render correo');
    try {
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (cargandoPage === false && formData === null) {
        return (
          <div>
            <label> Sin data</label>
          </div>
        );
      }
      return (
        <div className="m-4">
          <div className="flex justify-between" >
            <h2 className="font-bold">
              {titulo}
            </h2>
            <button
              type="button"
              className={ESTILO_BOTON_LISTAR_ATRAS}
              onClick={handleAtrasClick}
            >
              ATRAS
            </button>
          </div>
          {informacionBasicaForm()}
          <div className="mt-4 flex justify-end">
            <button
              type="button"
              className={ESTILO_BOTON_GENERAL_ACEPTAR}
              onClick={handleSaveClick}
            >
              GUARDAR
            </button>
          </div>
        </div>
      );
    } catch (err) {
      console.log('Conductor render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
